import { Range } from './common';
import { Coupon } from './coupon';
import { Listing } from './listing';
import { TransactionStatus } from './transaction';
import {
  Batch,
  Package,
  Resources,
  TicketBookingPackageWithoutResources,
  TimeBookingPackage,
  Venue,
  VenueType
} from './venue';

export enum BookingStatus {
  PAID_ONLINE = 'PAID_ONLINE',
  PAID_OFFLINE = 'PAID_OFFLINE',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED'
}

export enum PaymentMode {
  OFFLINE = 'OFFLINE',
  PAY_AT_VENUE = 'PAY_AT_VENUE',
  ONLINE = 'ONLINE'
}

export enum PaymentMethod {
  CARD = 'CARD',
  UPI = 'UPI',
  CASH = 'CASH'
}

export enum BookingMode {
  OFFLINE = 'OFFLINE', // Booked through zittle dashboard
  ONLINE = 'ONLINE' // Booked through Zittle hosted websited or through custom domain
}

export enum BookingHistoryType {
  UPCOMING = 'UPCOMING',
  PREVIOUS = 'PREVIOUS'
}

export enum AmountComponent {
  TICKET_PRICE = 'TICKET_PRICE',
  DISCOUNT = 'DISCOUNT',
  COUPON_DISCOUNT = 'COUPON_DISCOUNT',
  PAYMENT_CHARGES = 'PAYMENT_CHARGES',
  TAX = 'TAX',
  CONVENIENCE_FEE = 'CONVENIENCE_FEE'
}

// TODO: Validate if we need to store all the package details in this
export interface BaseTicketDetail {
  packageId: string;
  resources: Resources;
  meta?: Pick<Package, 'title' | 'price' | 'discount'>;
}

export interface TicketBookingDetail extends BaseTicketDetail {
  meta?: Pick<TicketBookingPackageWithoutResources, 'title' | 'price' | 'discount' | 'resourcesToBook'>;
}

export interface TimeBookingDetail extends BaseTicketDetail {
  bookedForTime: Range<Date>; // Each ticket dipcts booking of different time
  meta?: Pick<TimeBookingPackage, 'title' | 'price' | 'discount' | 'duration'>;
}

export type Ticket = TicketBookingDetail | TimeBookingDetail;

export interface BaseBooking {
  id?: string;
  userId: string;
  propId: string;
  listingId: string;
  venueId: string;
  venueType?: VenueType;
  // tickets: Array<TicketDetail>;
  coupon?: {
    code: string;
    meta?: Omit<Coupon, 'propId' | 'type' | 'expiry'>;
  };
  bookingStatus?: BookingStatus;
  totalAmount: number;
  amountBreakdown: Partial<Record<AmountComponent, number>>;
  transactionStatus?: TransactionStatus;
  bookingMode?: BookingMode;
  paymentMode?: PaymentMode;
  paymentMethod?: PaymentMethod;
  createdAt?: Date;
  transactionId?: string;
  meta?: {
    listing: Pick<Listing, 'title' | 'listingType'>;
    venue: Pick<Venue, 'location' | 'address' | 'phoneNumber'>;
  };
}

export interface TicketBooking extends BaseBooking {
  venueType: VenueType.TICKET_BOOKING;
  /**
   * Choice of selected session batches
   */
  slotId: string;
  sessionBatches: Array<Batch>;
  tickets: Array<TicketBookingDetail>;
}

export interface TimeBooking extends BaseBooking {
  venueType: VenueType.TIME_BOOKING;
  tickets: Array<TimeBookingDetail>;
}

export type Booking = TicketBooking | TimeBooking;
